import { useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../../core/auth/authSlice";
import { PostApiRoutes } from "../../../../../shared/api-routes/post/post.api-routes";
import { User } from "../../../../../shared/models";
import http from "../../../../../shared/utils/http";
import ClickIconMenu from "../../../../essentials/icon-buttons/click-icon/ClickIconMenu";
import ToggleIcon from "../../../../essentials/icon-buttons/toggle-icon/ToggleIcon";
import AcedModal from "../../../../essentials/modals/aced-modal/AcedModal";
import ConfirmationModal from "../../../../essentials/modals/confirmation-modal/ConfirmationModal";
import UserCard from "../../../../essentials/user-card/UserCard";
import LikeModal from "../../like-modal/LikeModal";
import { CommentInfo } from "./Comment";
import "./Comment.scss";

export interface CommentReplyProps {
	comment: CommentInfo;
	onDeleteReply: (reply_id: string) => void;
	postId: string;
	onClickReply: any;
}

const CommentReply: React.FC<CommentReplyProps> = ({
	comment,
	onDeleteReply,
	postId,
	onClickReply,
}) => {
	const [isDeleteModalOpen, setDeleteModalOpen] = useState<boolean>();
	const [isLiked, setIsLiked] = useState<boolean>(comment.isLiked);
	const [likesCount, setLikesCount] = useState<number>(comment.likesCount);

	const { actorId } = useSelector(selectUser) as User;

	const deleteComment = () => {
		http
			.delete(PostApiRoutes.DELETE_COMMENT(postId, comment.id))
			.then((res) => {
				setDeleteModalOpen(false);
				onDeleteReply(comment.id);
			});
	};

	const likeUnlike = () => {
		if (isLiked) {
			http.delete(PostApiRoutes.UNLIKE_COMMENT(postId, comment.id));
			setIsLiked(false);
			setLikesCount(likesCount - 1);
		} else if (!isLiked) {
			http.post(PostApiRoutes.LIKE_COMMENT(postId, comment.id));
			setIsLiked(true);
			setLikesCount(likesCount + 1);
		}
	};

	const [isLikeModalOpen, setLikeModalOpen] = useState<boolean>(false);

	const menuOptions = () => {
		const normalOptions = [{ text: "Copy Link" }];
		return actorId === comment.author.id
			? [
					{ text: "Edit" },
					{
						text: "Delete",
						color: "red",
						action: () => {
							setDeleteModalOpen(true);
						},
					},
					...normalOptions,
			  ]
			: normalOptions;
	};

	return (
		<div className="comment">
			<div className="comment-content">
				<div>
					<UserCard
						userInfo={comment.author}
						size="s"
					/>
					<p className="comment-text">{comment.content}</p>
				</div>
				<div className="actions">
					<ClickIconMenu
						icon="dots"
						size="s"
						options={menuOptions()}
					/>
					{/* <ClickIcon icon="edit" size="s" tooltip="Edit Comment (WIP)" />
            <DeleteButton
              onClick={() => {
                setDeleteModalOpen(true);
              }}
              tooltip="Delete Comment"
              size="s"
            />*/}
					<ConfirmationModal
						title="Delete comment?"
						state={{
							isModalOpen: isDeleteModalOpen,
							setModalOpen: setDeleteModalOpen,
						}}
						onConfirm={deleteComment}
					/>
				</div>
			</div>
			<AcedModal
				state={{ isModalOpen: isLikeModalOpen, setModalOpen: setLikeModalOpen }}
				title="Likes"
			>
				<LikeModal
					post_id={postId}
					comment_id={comment.id}
				/>
			</AcedModal>
			<div className="comment-footer">
				<div className="comment-footer-actions">
					<div className="element">
						<ToggleIcon
							icon="like"
							onClick={likeUnlike}
							isToggled={isLiked}
							size={16}
							tooltip="Like Comment"
						/>
						<p
							className="activex"
							onClick={() => {
								setLikeModalOpen(true);
							}}
						>
							{likesCount}
						</p>
					</div>

					<p
						className="activex"
						onClick={onClickReply}
					>
						Reply
					</p>
				</div>
			</div>
		</div>
	);
};

export default CommentReply;
